export default {
      id: "rotate-usage",
      viewBox: "0 0 450 450",
      url: __webpack_public_path__ + "img/icons.a13474e0.svg#rotate",
      toString: function () {
        return this.url;
      }
    }